<script>
import { mapGetters, mapMutations } from 'vuex'
import tinycolor from 'tinycolor2'

export default {
  props: {
    displayLabel: { type: Boolean, default: true }
  },
  data() {
    return {
      organizationToSelect: null
    }
  },
  computed: {
    ...mapGetters(['selectedOrganization', 'organizations']),
    dropdownTextColor() {
      const theme = this.$vuetify.theme.themes.light
      const color = tinycolor(theme.sidebarLink)
      const isPureWhite =
        color.isValid() && color.toHexString().toLowerCase() === '#ffffff'

      return isPureWhite ? theme.sidebarBackground : theme.sidebarLink
    }
  },
  methods: {
    ...mapMutations(['SET_SELECTED_ORGANIZATION']),
    pickOrganization(organization) {
      if (
        organization &&
        organization.OrganizationId !== this.selectedOrganization.OrganizationId
      ) {
        this.SET_SELECTED_ORGANIZATION(organization)
        this.executeOrganizationContextSwitch(organization)
        this.$emit('organization-selected', organization)
      }
    },
    executeOrganizationContextSwitch(organization) {
      this.$store.dispatch('getWhiteLabelAssets').then(() => {
        this.$store.dispatch('getThemeColors')
      })
      switch (this?.$route?.name) {
        case 'inbox':
          this.$store.dispatch('fetchUserInboxes', organization)
          this.$store.dispatch('fetchLatestInboxSync', organization)
          this.$store.dispatch('fetchClientFilters')
          this.$store.dispatch('fetchInboxFilters')
          this.$store.dispatch('fetchInbox')
          break
        case 'else':
          break
        default:
          break
      }
    }
  }
}
</script>
<template>
  <div v-if="organizations.length" id="organization-select">
    <v-select
      :value="selectedOrganization"
      :items="organizations"
      dense
      hide-details
      append-icon="mdi-chevron-down"
      :style="displayLabel && 'paddingTop:10px'"
      :item-text="organization => organization.OrganizationName"
      :item-value="organization => organization"
      :no-data-text="$t('global.no.data.text')"
      @change="selected => pickOrganization(selected)"
    >
      <template #label>
        <small
          v-if="displayLabel"
          :style="{ color: $vuetify.theme.themes.light.sidebarLink }"
        >
          {{ $t('global.organization') }}
        </small>
      </template>
      <template #item="{item}">
        <v-list-item-content>
          <v-list-item-title :style="{ color: dropdownTextColor }">
            {{ item.OrganizationName }}
          </v-list-item-title>
        </v-list-item-content>
      </template>
      <template #selection="{item}">
        <v-list-item-content>
          <v-list-item-title
            :style="{ color: $vuetify.theme.themes.light.sidebarLink }"
          >
            {{ item.OrganizationName }}
          </v-list-item-title>
        </v-list-item-content>
      </template>
    </v-select>
  </div>
</template>
<style scoped>
#organization-select >>> .v-select__slot {
  top: 7px;
}

#organization-select >>> .v-select__selections {
  width: 10em;
}

#organization-select >>> div.v-select__selection.v-select__selection--comma {
  font-size: 14px !important;
  letter-spacing: 1px;
}

#organization-select >>> .v-select__selections input {
  display: none;
}

#organization-select >>> .v-input__slot:before,
#organization-select >>> .v-input__slot:after {
  display: none;
}
</style>
